/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Icon, Text } from 'sarsaparilla';

import TopographyMapSVG from './TopographyMapSVG';

function MapCTAWrapper({
    message = 'Click below to view map',
    forceDisplayMap = false,
    children,
}) {
    const [isMapDisplayed, setIsMapDisplayed] = useState(forceDisplayMap);

    useEffect(() => {
        setIsMapDisplayed(forceDisplayMap);
    }, [forceDisplayMap]);

    const handleClick = () => {
        setIsMapDisplayed(true);
    };

    const renderPlaceholder = () => {
        return (
            <div className="display-map-container">
                <TopographyMapSVG />
                <Box padding="gutter" shadow={0} className="display-map-container-loader">
                    <div className="display-map-container-loader-wrapper">
                        <div className="map-pin">
                            <Icon iconName="pin" size="xl" />
                        </div>

                        <Text fontWeight="semibold">{message}</Text>

                        <Button
                            appearance="tertiary"
                            onClick={handleClick}
                            clickTagCategory="rec-widget"
                            clickTagAction={`display-map-cta`}
                            clickTagLabel="display-map"
                        >
                            Display Map
                        </Button>
                    </div>
                </Box>
            </div>
        );
    };

    return <>{isMapDisplayed ? children : renderPlaceholder()}</>;
}

MapCTAWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    campgroundName: PropTypes.string,
    forceDisplayMap: PropTypes.bool,
};

export default MapCTAWrapper;
